import Environment from './Environment.js'
import Terrain from './Terrain.js'
import Models from './Models.js'
import Trees from './Trees.js'
import Flags from './Flags.js'
import Clouds from './Clouds.js'
import Countryside from './Countryside.js'

export default class World {
    constructor() {
        this.terrain = new Terrain()
        this.environment = new Environment()
        this.models = new Models(this.terrain)
        this.trees = new Trees(this.terrain)
        this.flags = new Flags(this.terrain)
        this.clouds = new Clouds()
        this.countryside = new Countryside()
    }

    update() {
        this.terrain.update()
        this.trees.update()
        this.flags.update()
    }

    destroy() {

        const modules = [
            this.terrain,
            this.trees,
            this.flags,
            this.clouds,
            this.countryside,
            this.environment
        ];

        modules.forEach(obj => {
            if (obj?.destroy) obj.destroy();
        });

        this.terrain = null;
        this.environment = null;
        this.flags = null;
    }
}
